export default "__VITE_ASSET__CF5Eo0iE__"